/**
 * Global inline onclick handler for Smart Wishlist CTAs (grids, resource-card, search, etc.).
 * PDP title wishlist uses wislistButtonpdp in blocks/product-pdp-title.liquid only.
 */
(function () {
  function triggerSmartWishlist(ele) {
    if (!ele || !ele.querySelector) return;
    const smart = ele.querySelector('.smartwishlist');
    if (smart) smart.click();
  }

  window.wislistButton = function wislistButton(event, ele) {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
    triggerSmartWishlist(ele);
  };
})();
